import '../../styles/pages/structure.scss';

const $root = document.querySelector('body');
$root.classList.add('ownership');